import { Component } from "react"
import "./PremiumPage.css"


class FeatureList extends Component {
    render() {
        return (
            <div className="plan-features-container">
                <p className="plan-features-subtitle">Lifetime Access Includes</p>
                <ul className="plan-features plan-features-grid">
                    <li><span className="plan-check">&#10003;</span> Unlimited valuations</li>
                    <li><span className="plan-check">&#10003;</span> Price trend graphs</li>
                    <li><span className="plan-check">&#10003;</span> Access all comparables</li>
                    <li><span className="plan-check">&#10003;</span> Neighbourhood insights</li>
                </ul>
            </div>
        )
    }
}

export default FeatureList
